export default {
  'Enter a promo code! First limit people receive amount coins':
    'Introduza o código promocional! Os primeiros recebem uma quantidade de moedas',
};
